import script from "./editkejian.vue?vue&type=script&setup=true&lang=js"
export * from "./editkejian.vue?vue&type=script&setup=true&lang=js"

import "./editkejian.vue?vue&type=style&index=0&id=a7d2e0f4&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7d2e0f4"]])

export default __exports__